<template>
  <v-overlay style="background-color: rgba(20, 20, 20, .6); z-index: 10001" v-if="value" :value="value">
    <iframe
      id="inlineFrameExample"
      frameborder="0"
      style="overflow:hidden;height:88vh;width:88vw;margin:auto;background-color: rgba(20, 20, 20, .6)"
      height="100%"
      width="100%"
      :src="`/back-office/customer/${clientId}/payment/edit?iframe=true&booking_id=${bookingId}&status=${status}`"
    ></iframe>
    <v-btn icon absolute @click="closeIframe" class="ml-4"><v-icon size="50" color="white">mdi-close</v-icon></v-btn>
  </v-overlay>
</template>

<script>
export default {
  props: ['value', 'clientId', 'bookingId', 'status'],

  methods: {
    closeIframe() {
      this.value = false
    },
  },

  watch: {
    value(val) {
      this.$emit('input', val)
    },
  },
}
</script>
